import React, { createContext, useState } from 'react';

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modals, setModals] = useState({
    about: false,
    tableView: false,
    popup: true,
    // other modals...
  });
  const [selectedLocation, setSelectedLocation] = useState(null);

  const openModal = (modalName, locationData = null) => {
    setModals(prev => ({ ...prev, [modalName]: true }));
    if (locationData) {
      setSelectedLocation(locationData);
    }
  };

  const closeModal = (modalName) => {
    setModals(prev => ({ ...prev, [modalName]: false }));
    if (modalName === 'tableView') {
      setSelectedLocation(null);
    }
  };

  return (
    <ModalContext.Provider value={{ modals, openModal, closeModal, selectedLocation }}>
      {children}
    </ModalContext.Provider>
  );
};